import { Address } from "../../../features/address"
import { VatCondition } from "../../administration"

export type SalePoint = {
	apiId: number
    apiCompanyId: number
	apiSubsidiaryId: number
	code: string
	fiscalId: number
	taxId: number
}

export type Company = {
    id: string
    code: string
    name: string
    legalName: string
    taxIds:{
        taxId: number
        main: boolean
        salePoint?: SalePoint
        collectionAgentProvinces?: string[]
    }[]
    websiteUrl?: string
    email: string
    phone?: number
    logoUrl?: string
    address: Address
    vatCondition: VatCondition
    grossIncomeCode?: number
    activityStartDate?: string
}

export type Bookmark = {
    routePath: string
    label: string
    order: number
}

// A card of the home dashboard as the user configured it. x, y, w, h are its place in the wide screen grid
// (12 columns): without them the card is placed at the end
export type DashboardWidgetPreference = {
    id: string
    size: 's' | 'm' | 'l'
    visible: boolean
    x?: number
    y?: number
    w?: number
    h?: number
}

export type User = {
    id: string
    name?: string
    email?: string
    pictureUrl?: string
    bookmarks?: Bookmark[]
    // Home dashboard configuration by company (a user can belong to several, with different roles)
    dashboards?: Record<string, DashboardWidgetPreference[]>
}

export enum UserRole {
    ADMINISTRATION = 'Administration',
    LOGISTICS = 'Logistics',
    MANAGER = 'Manager',
    PURCHASES = 'Purchases',
    SALES = 'Sales',
    WAREHOUSE = 'Warehouse'
}

export enum RequestStatus {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    DENIED = 'Denied'
}

export type Request = {
    companyId: string
    id: string
    userId: string
    role: UserRole
    status: RequestStatus
    archived?: boolean
    negativeStateUserId?: string
    negativeStateAt?: string
}

export enum IdentifierType {
    PERSONAL_ID = 'PersonalId',
    TAX_ID = 'TaxId'
}
